import React, { useEffect, useState } from "react";
import { CiCloudOff, CiCloudOn } from "react-icons/ci";

import "./NetworkTab.scss";
import { FaWifi } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { updateNetworkStatus } from "../../redux/features/home-slice";

const NetworkTab = ({ status }) => {
  const [open, setOpen] = useState(true);
  const dispatch = useDispatch();

    useEffect(() => {
      if (status === "offline") {
        setOpen(true);
      } else if (status) {
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          dispatch(updateNetworkStatus({ status: null }));
        }, 1000);
      } else {
        setOpen(false);
      }
    }, [status]);

  useEffect(() => {
    const newVh = window.innerHeight;
    if (open) {
      document.documentElement.style.setProperty("--top", "50px");
        document.documentElement.style.setProperty("--vh", `${newVh - 50}px`);
    } else {
      document.documentElement.style.setProperty("--top", "0px");
      document.documentElement.style.setProperty("--vh", `${newVh}px`);
    }
  }, [open]);

  if (!open) return null;
  return (
    <div
      className={`network-tab ${
        status === "offline" ? "danger" : status === "online" ? "success" : ""
      }`}
    >
      {status === "offline" ? (
        <CiCloudOff />
      ) : status === "online" ? (
        <FaWifi />
      ) : (
        <CiCloudOn />
      )}
      <p>
        {status === "offline"
          ? "You're in Offline Mode."
          : status === "online"
          ? "You're back online!"
          : "Syncing with cloud..."}
      </p>
    </div>
  );
};

export default NetworkTab;
